import { CustomLink } from '@/components/commons/typography/CustomLinkt'
import { Text } from '@/components/commons/typography/Text'
import { Title } from '@/components/commons/typography/Title'
import { SeparatorDot } from '@/components/commons/ui/SeparatorDot'
import { LoadingText } from '@/components/skeleton/TextSkeleton'
import { getLinkSafeUrl } from '@/shared/utils'
import { useProfile, useIsMod } from 'containers/profile/hooks/useProfile'
import { DisplayNameWithBadge } from '@/components/user/DisplayNameWithBadge'

export const PersonalInfo = () => {
  const { profile, isLoading } = useProfile()
  const isMod = useIsMod()

  return (
    <>
      <div className="flex flex-column gap-2 gap-8--tablet flex-row--tablet items-center--tablet">
        {LoadingText(
          <Title variation="small">
            <DisplayNameWithBadge profile={profile} />
          </Title>,
          isLoading
        )}

        <div className="hidden block--desktop">
          <SeparatorDot />
        </div>

        {LoadingText(
          <Text variation="small" colorClass="text-tertirary">
            {profile?.username}
          </Text>,
          isLoading,
          '40%',
          16
        )}

        {isMod && (
          <>
            <div className="hidden block--desktop">
              <SeparatorDot />
            </div>
            <Text
              variation="small"
              colorClass="text-secondary"
              className="hidden block--desktop"
              style={{
                fontFamily: 'Courier New, Courier, monospace',
                backgroundColor: '#f6f6f6',
                fontWeight: 'bold',
                padding: '2px 4px',
                borderRadius: '4px',
                fontSize: '0.9em',
                whiteSpace: 'pre',
                border: '1px solid #ccc',
              }}
            >
              {profile?.id}
            </Text>
          </>
        )}
      </div>
      <div className="flex flex-column gap-8--tablet flex-row--tablet items-center--tablet">
        <div>
          {LoadingText(
            <Text
              sizeClass="text-13"
              style={{ wordWrap: 'break-word', overflowWrap: 'break-word' }}
            >
              {profile?.title}
            </Text>,
            isLoading,
            '100%',
            16
          )}
        </div>

        {((profile?.isEmployer &&
          profile?.isEmployer?.companyWebsite?.length > 0) ||
          isLoading) &&
          LoadingText(
            <>
              <div className="hidden block--desktop">
                <SeparatorDot />
              </div>
              <CustomLink
                className="flex"
                href={getLinkSafeUrl(profile?.isEmployer?.companyWebsite)}
                target="_blank"
                variation="xSmall"
                weightClass="font-bold"
              >
                {profile?.isEmployer?.companyName
                  ? profile?.isEmployer?.companyName
                  : profile?.isEmployer?.companyWebsite}
              </CustomLink>
            </>,
            isLoading,
            '50%',
            16
          )}
      </div>
    </>
  )
}
